import { render } from "./FinishMessage.vue?vue&type=template&id=d946c9d6&scoped=true"
import script from "./FinishMessage.vue?vue&type=script&lang=js"
export * from "./FinishMessage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d946c9d6"

export default script